<script lang="ts">
    import { RewardsVipTiersSingleProgressWidgetDefinition } from "@apps/rewards/constants/definitions";
    import { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";

    import Widget from "@components/Widget.svelte";
    import type { LoggerInterface } from "@interfaces/LoggerInterface";

    export let dynamicImportManager: DynamicImportManager;
    export let logger: LoggerInterface;
</script>

{#await dynamicImportManager.importDefault(RewardsVipTiersSingleProgressWidgetDefinition, true) then RewardsVipTiersSingleProgressWidget}
    <Widget
        class="gw-rd-vip-tiers-single-progress-widget-container"
        widget={RewardsVipTiersSingleProgressWidget}
        params={[
            {
                isWidgetShadowRootEnabled: true,
            },
            logger,
        ]}
    />
{:catch error}
    {console.error(
        "Failed to load RewardsVipTiersSingleProgressWidget module",
        error
    )}
{/await}
